import { render, staticRenderFns } from "./AdminProjectsOverview.vue?vue&type=template&id=ebdd7db8"
import script from "./AdminProjectsOverview.vue?vue&type=script&lang=js"
export * from "./AdminProjectsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports